var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudUpDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3292_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.2694H4.43816C2.7235 14.2667 1.3335 12.9287 1.3335 11.278C1.3335 9.62802 2.7235 8.29002 4.43816 8.29002C4.70016 7.11535 5.63416 6.15669 6.88816 5.77469C8.1415 5.39335 9.5255 5.64602 10.5175 6.44135C11.5095 7.23469 11.9588 8.44602 11.6975 9.62069H12.3575C13.2775 9.62069 14.0708 10.1614 14.4428 10.9447",
    stroke: "#303234",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4001,
    cy: 14.4001,
    r: 2.8,
    fill: "#EED067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4001 15.2001V13.6001M12.4001 13.6001L13.2001 14.4001M12.4001 13.6001L11.6001 14.4001",
    stroke: "white",
    strokeWidth: 0.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3292_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.800049)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpDark);
export default __webpack_public_path__ + "static/media/cloud-up-dark.f3b2f0f8675f2177c27a499764787ded.svg";
export { ForwardRef as ReactComponent };